import { Initialize } from 'pacto';

import { Password as View } from '../views/Password';


export class Action extends Initialize {
  get settings() {
    return {
      selector: '.password',
      namespace: 'password:views',
      view: View,
    };
  }
}
